import { Fragment, memo, useMemo } from 'react';

import { Flame } from 'lucide-react';

import Chip from '@mui/material/Chip';

import { ResetDropRollButton } from './resetDropRollButton/ResetDropRollButton';
import { TelegramDropRewardsColumn } from './telegramDropTableColumns/TelegramDropRewardsColumn';
import { TelegramDropTableActionsColumn } from './telegramDropTableColumns/TelegramDropTableActionsColumn';

import css from './TelegramDropTable.module.css';

import { Card } from 'v2/components/card/Card';
import { CardHeader } from 'v2/components/card/cardHeader/CardHeader';
import { DataTable } from 'v2/components/dataTable/DataTable';
import { TableColumn } from 'v2/types';
import { TelegramBotDropModel } from 'v2/types/TelegramBotSettingsModel';
import { formatNumber } from 'v2/utils';

interface TelegramDropTableProps {
  drops: TelegramBotDropModel[];
  onRevalidate: VoidFunction;
}

export const TelegramDropTable = memo<TelegramDropTableProps>(({ drops, onRevalidate }) => {
  const columns: TableColumn<TelegramBotDropModel>[] = useMemo(
    () => [
      {
        key: 'rollCount',
        label: 'Rolls Count',
        render: (row) => formatNumber(row.rollCount),
      },
      {
        key: 'chanceToWin',
        label: 'Chance to Win',
        align: 'center',
        render: (row) => <Chip className="font-medium" label={row.chanceToWin + '%'} size="small" color="success" />,
      },
      {
        key: 'rewardsSent',
        label: 'Rewards Sent',
        align: 'center',
        render: (row) => <TelegramDropRewardsColumn drop={row} />,
      },
      {
        key: 'actions',
        align: 'right',
        render: (row) => <TelegramDropTableActionsColumn drop={row} onRevalidate={onRevalidate} />,
      },
    ],
    [onRevalidate]
  );

  return (
    <Fragment>
      <Card>
        <div className={css.telegramDropTableTitle}>
          <CardHeader title="All Drops" icon={Flame} />

          <ResetDropRollButton onRevalidate={onRevalidate} />
        </div>

        <DataTable columns={columns} data={drops} />
      </Card>
    </Fragment>
  );
});

TelegramDropTable.displayName = 'TelegramDropTable';
